import React from "react";
import { withRouter } from "react-router";
import AgregarCiudad from "./AgregarCiudad";
const EditarCiudad = props => {
    return <AgregarCiudad editar={true} />;
};

export default withRouter(EditarCiudad);
